// PaymentForm.jsx — Step 2: Stripe card element
import { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { Row, Col } from 'react-bootstrap';
import SpinnerButton from '../../../Componet/Button/SpinnerButton';
import { VehicleTypes } from '../../../store/Utility/Status';

export default function PaymentForm({ orderData, clientSecret, totalAmount }) {
    const stripe = useStripe();
    const elements = useElements();
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;


        const { error: submitError } = await elements.submit();
        if (submitError) {
            // Show error to customer (e.g., "Card number is incomplete")
            setMessage(submitError.message);
            return;
        }

        setLoading(true);
        const { error } = await stripe.confirmPayment({
            elements,
            clientSecret,
            confirmParams: {
                // Make sure to change this to your payment completion page
                return_url: `${window.location.origin}/order-complete`,
            },
        });

        // Only reached if there's an error (no redirect occurred)
        setMessage(error.message);
        setLoading(false);
    };

    return (
        <form onSubmit={handleSubmit}>
            <Row className='mb-5'>
                <Col md={10}>
                    <span className="text"><b>Order Details: </b>{orderData.vehicleType == VehicleTypes.Car ? 'Car/SUV Inspection' :
                        orderData.vehicleType == VehicleTypes.Commercial ? 'Truck/Van Inspection' :
                            orderData.vehicleType == VehicleTypes.Motorcycle ? 'Motorcycle Inspection' :
                                orderData.vehicleType == VehicleTypes.RV ? 'RV Inspection' : null
                    }
                        {orderData.isCarfaxReportRequested ? ' & CARFAX Report' : null}
                    </span>
                </Col>
                <Col md={2}>
                    <span className="text"><b>Total: </b>$ {totalAmount?.toFixed(2)}</span>
                </Col>

            </Row>

            <Row form className='mt-3 mb-3'>
                <Col md={12}>
                    <PaymentElement />   {/* Stripe's pre-built card UI */}

                    {message && <p style={{ color: 'red' }}>{message}</p>}

                    {/* <button type="submit" disabled={loading || !stripe}>
                {loading ? 'Processing...' : 'Pay $29.99'}
            </button> */}
                </Col>

            </Row>


            <Row>
                <Col md={12}>
                    <div style={{ color: "red", fontSize: "0.9rem" }}>
                        {/* {Object.keys(message).length > 0 ? Object.values(message).map(item => <div className="row"><span>* {item}</span></div>) : null} */}
                    </div>
                </Col>
                <Col md={10}>
                </Col>
                <Col md={2}>
                    <SpinnerButton type="submit" className="btn btn-primary btn-sm w-100 w-md-auto mt-3" disabled={loading || !stripe} loading={loading} text="Complete Payment" />
                </Col>
            </Row>
        </form>
    );
}